// extracted by mini-css-extract-plugin
module.exports = {"movie":"movie-module--movie--IYUpK","movie__wrap":"movie-module--movie__wrap--3Hv0r","movie__iframe":"movie-module--movie__iframe--3Di3K"};